import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./Yangilik.css";
import newsData from "./YangilikData";
import YangilikModal from "./YangilikModal";

function Yangilik() {
    const navigate = useNavigate();

    const [selectedNewsId, setSelectedNewsId] = React.useState(null);

    const handleLoadMore = () => {
        toast.warning("Boshqa yangilik yo'q");
    };

    const handleDetail = (id) => {
        setSelectedNewsId(id);
    };

    return (
        <div className="yangilik-quti">
            <h1 className="yangilik-header">Yangiliklar</h1>
            <div className="yangilik-grid">
                {newsData.map((item) => (
                    <div className="yangilik-card" key={item.id}>
                        <div className="yangilik-rasm">
                            <img src={item.image} alt={item.title} />
                        </div>
                        <div className="yangilik-content">
                            <div className="yangilik-title">{item.title}</div>
                            <p style={{ fontSize: "0.9vw", color: "inherit", opacity: 0.8 }}>
                                {item.desc}
                            </p>
                            <button
                                className="yangilik-btn"
                                onClick={() => handleDetail(item.id)}
                            >
                                Batafsil
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            <button
                className="yangilik-yuklash-btn"
                onClick={handleLoadMore}
            >
                Yana yuklash
            </button>

            {/* Detail Modal */}
            {selectedNewsId && (
                <YangilikModal
                    newsId={selectedNewsId}
                    onClose={() => setSelectedNewsId(null)}
                />
            )}
        </div>
    );
}

export default Yangilik;
